import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import { PageHeader, Form, FormGroup, Row, Col, FormControl, Button, ControlLabel } from 'react-bootstrap';
import {Link} from 'react-router-dom';
// SHARED
import { axiosInstance } from '../utils/ApiHelper'
import Logo from '../core/components/Logo'
import ToggleSwitch from '../core/components/ToggleSwitch'

class ManageEmailSubscriptionsContainer extends React.Component {
  state = {
    weekly_report_enabled: false,
    monthly_report_enabled: false,
    yearly_report_enabled: false,
    promotions_enabled: false,
    isFetching: false,
    formErrorMessage: ''
  }

  componentDidMount(){
    // Get state from server
    const { params } = this.props
    let url = 'manage_subscriptions/' + params.token_id

    // Update email subscriptions with server
    axiosInstance.get(url).then(response => {
      if (response.status != 200) {
        this.setState(Object.assign({}, this.state, {
          formErrorMessage: response.data.result
        }))

      } else {
        this.setState(Object.assign({}, this.state, {
          weekly_report_enabled: response.data.weekly_report_enabled,
          monthly_report_enabled: response.data.monthly_report_enabled,
          yearly_report_enabled: response.data.yearly_report_enabled,
          promotions_enabled: response.data.promotions_enabled
        }))

      }
    })
  }

  handleOnSubmit(event){

    event.preventDefault()

    // Set fetching state
    this.setState(Object.assign({}, this.state, {
        isFetching: true
    }))

    const { params } = this.props
    let url = 'manage_subscriptions/' + params.token_id
    var data = {}
    data["weekly_report_enabled"] = this.state.weekly_report_enabled
    data["monthly_report_enabled"] = this.state.monthly_report_enabled
    data["yearly_report_enabled"] = this.state.yearly_report_enabled
    data["promotions_enabled"] = this.state.promotions_enabled

    // Update email subscriptions with server
    axiosInstance.put(url,data).then(response => {
      if (response.status != 200) {
        // Error
        this.setState(Object.assign({}, this.state, {
          formErrorMessage: response.data.error_message,
          isFetching: false
        }))
      } else {
        // Success
        this.setState(Object.assign({}, this.state, {
          weekly_report_enabled: response.data.weekly_report_enabled,
          monthly_report_enabled: response.data.monthly_report_enabled,
          yearly_report_enabled: response.data.yearly_report_enabled,
          promotions_enabled: response.data.promotions_enabled,
          isFetching: false
        }))
      }
    })
  }

  handleChangeWeeklyReports(event, isInputChecked) {
    this.setState({ weekly_report_enabled: isInputChecked });
  }

  handleChangeMonthlyReports(event, isInputChecked) {
    this.setState({ monthly_report_enabled: isInputChecked });
  }

  handleChangeYearlyReports(event, isInputChecked) {
    this.setState({ yearly_report_enabled: isInputChecked });
  }

  handleChangePromotions(event, isInputChecked) {
    this.setState({ promotions_enabled: isInputChecked });
  }

  render() {

    const errorsBox = {
        width: "100% ",
        textAlign: "center",
        color: "#d02f2f",
        marginTop: "15px"
    }

    return (
      <div className="manage-email-subscriptions-container">
        <div className="center">
          <Form className="credentials-form" onSubmit={!this.state.isFetching ? this.handleOnSubmit.bind(this) : null} horizontal>
            <Logo />

            <FormGroup controlId="formTitle">
             <Col sm={12}>
               <h3 className="form-title">Manage Email Subscriptions</h3>
             </Col>
            </FormGroup>

            <FormGroup controlId="weeklyReportsEnabled">
               <Col componentClass={ControlLabel} sm={5}>
                Weekly Reports
               </Col>
               <Col className="toggle-switch-column" sm={7}>
                <ToggleSwitch type="weeklyReports" defaultToggled={this.state.weekly_report_enabled} onToggle={this.handleChangeWeeklyReports.bind(this)} />

               </Col>
            </FormGroup>

            <FormGroup controlId="monthlyReportsEnabled">
             <Col componentClass={ControlLabel} sm={5}>
               Monthly Reports
             </Col>
             <Col className="toggle-switch-column" sm={7}>
               <ToggleSwitch type="monthlyReports" defaultToggled={this.state.monthly_report_enabled} onToggle={this.handleChangeMonthlyReports.bind(this)} />
             </Col>
            </FormGroup>

            <FormGroup controlId="yearlyReportsEnabled">
             <Col componentClass={ControlLabel} sm={5}>
               Yearly Reports
             </Col>
             <Col className="toggle-switch-column" sm={7}>
               <ToggleSwitch type="yearlyReports" defaultToggled={this.state.yearly_report_enabled} onToggle={this.handleChangeYearlyReports.bind(this)} />
             </Col>
            </FormGroup>

            <FormGroup controlId="promotionsEnabled">
             <Col componentClass={ControlLabel} sm={5}>
               Promotional Emails
             </Col>
             <Col className="toggle-switch-column" sm={7}>
               <ToggleSwitch type="promotions" defaultToggled={this.state.promotions_enabled} onToggle={this.handleChangePromotions.bind(this)} />
             </Col>
            </FormGroup>

            <FormGroup>
             <Col sm={12}>
               <Button disabled={this.state.isFetching} className="btn-main-green" bsSize="large" type="submit" >
                {this.state.isFetching ? "Saving..." : "Save"}
               </Button>

               <div style={errorsBox}>
                 {this.state.formErrorMessage}
               </div>
             </Col>

           </FormGroup>

          </Form>
        </div>
      </div>

    )
  }
}

ManageEmailSubscriptionsContainer.propTypes = {
};

export default connect()(ManageEmailSubscriptionsContainer)



// WEBPACK FOOTER //
// ./src/subscriptions/ManageEmailSubscriptionsContainer.js